var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHzupn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M35.893 26L25.602 36.29M25.602 26l10.291 10.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M18.649 16.347l2.172-3.76M20.619 31.039l-1.68 2.908a6.92 6.92 0 11-11.985-6.923l5.202-8.907"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.859 22.439l-7.703-4.324.639-1.204 4.639-8.029a6.92 6.92 0 1111.985 6.923l-2.295 3.973"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 23.602,
    cy: 9.707,
    r: 1.218
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHzupn);
export default __webpack_public_path__ + "static/media/HZUPN.648a873caa0f7982661d2eb38c12f889.svg";
export { ForwardRef as ReactComponent };